import {
  CANCEL_PRESCRIPTION_ENABLED_ALL_SCREENS,
  CANCEL_PRESCRIPTION_ENABLED_WITHOUT_KARTE,
  CHAT_BUTTON_ENABLED_STATES,
  PRESCRIPTION_ACTIONS_DISABLED_STATES,
  PRESCRIPTION_NG_ENABLED_STATES,
  REVERT_CANCEL_REQUEST_ENABLED_STATES,
  VIDEO_BUTTON_ENABLED_STATES,
} from '@/common/constants/auth';

export type PrescriptionScreenContext = 'karte' | 'chat' | 'question' | '';

export function isCancelPrescriptionEnabled(
  state: string,
  screenContext: PrescriptionScreenContext,
): boolean {
  const enabledForAll = CANCEL_PRESCRIPTION_ENABLED_ALL_SCREENS.includes(state);
  const enabledWithoutKarte = CANCEL_PRESCRIPTION_ENABLED_WITHOUT_KARTE.includes(
    state,
  );

  if (screenContext === 'karte') {
    return enabledForAll;
  }

  return enabledForAll || enabledWithoutKarte;
}

export function isPrescriptionActionsBlocked(state: string): boolean {
  return PRESCRIPTION_ACTIONS_DISABLED_STATES.includes(state);
}

export function isChatButtonEnabled(state: string): boolean {
  return CHAT_BUTTON_ENABLED_STATES.includes(state);
}

export function isVideoButtonEnabled(state: string): boolean {
  return VIDEO_BUTTON_ENABLED_STATES.includes(state);
}

export function isPrescriptionNgEnabled(state: string): boolean {
  return PRESCRIPTION_NG_ENABLED_STATES.includes(state);
}

export function isRevertCancelRequestEnabled(state: string): boolean {
  return REVERT_CANCEL_REQUEST_ENABLED_STATES.includes(state);
}
